import { Link } from "react-router-dom";

export const CollectionBadge = ({ collection, includeLink = true }) => {
  if (!collection) {
    return null;
  }
  const { name, color } = collection;

  return (
    <div
      className="collection-chip position-relative small text-truncate"
      style={{ "--bs-chip-color": color }}
    >
      <span className="text-truncate">{name}</span>
      {includeLink && (
        <Link
          to={`/collections/${collection.uuid}`}
          className="stretched-link"
        />
      )}
    </div>
  );
};
